import { inject, Pipe } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
  standalone: false,
  name: 'safeHtml'
})
export class SafeHtmlPipe {
  sanitizer = inject(DomSanitizer)

  transform(value: any, args?: any): any {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
